var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { UIComponent, childrenExist, customPropTypes, createShorthandFactory, isFromKeyboard, commonPropTypes, } from '../../lib';
import Icon from '../Icon/Icon';
import Slot from '../Slot/Slot';
import { buttonBehavior } from '../../lib/accessibility';
import ButtonGroup from './ButtonGroup';
/**
 * A button indicates a possible user action.
 * @accessibility
 * Other considerations:
 *  - for disabled buttons, add 'disabled' attribute so that the state is properly recognized by the screen reader
 *  - if button includes icon only, textual representation needs to be provided by using 'title', 'aria-label', or 'aria-labelledby' attributes
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFromKeyboard: false,
        };
        _this.renderIcon = function (variables, styles) {
            var _a = _this.props, icon = _a.icon, iconPosition = _a.iconPosition, content = _a.content;
            return Icon.create(icon, {
                defaultProps: {
                    styles: styles.icon,
                    xSpacing: !content ? 'none' : iconPosition === 'after' ? 'before' : 'after',
                    variables: variables.icon,
                },
            });
        };
        _this.handleClick = function (e) {
            var disabled = _this.props.disabled;
            if (disabled) {
                e.preventDefault();
                return;
            }
            _.invoke(_this.props, 'onClick', e, _this.props);
        };
        _this.handleFocus = function (e) {
            _this.setState({ isFromKeyboard: isFromKeyboard() });
            _.invoke(_this.props, 'onFocus', e, _this.props);
        };
        return _this;
    }
    Button.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, variables = _a.variables, styles = _a.styles, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content, disabled = _b.disabled, iconPosition = _b.iconPosition;
        var hasChildren = childrenExist(children);
        return (React.createElement(ElementType, __assign({ className: classes.root, disabled: disabled, onClick: this.handleClick, onFocus: this.handleFocus }, accessibility.attributes.root, rest),
            hasChildren && children,
            !hasChildren && iconPosition !== 'after' && this.renderIcon(variables, styles),
            Slot.create(!hasChildren && content, {
                defaultProps: { as: 'span', className: classes.content },
            }),
            !hasChildren && iconPosition === 'after' && this.renderIcon(variables, styles)));
    };
    Button.displayName = 'Button';
    Button.className = 'ui-button';
    Button.propTypes = __assign({}, commonPropTypes.createCommon({
        content: 'shorthand',
    }), { circular: PropTypes.bool, disabled: PropTypes.bool, fluid: PropTypes.bool, icon: customPropTypes.itemShorthand, iconOnly: PropTypes.bool, iconPosition: PropTypes.oneOf(['before', 'after']), onClick: PropTypes.func, onFocus: PropTypes.func, primary: customPropTypes.every([customPropTypes.disallow(['secondary']), PropTypes.bool]), text: PropTypes.bool, secondary: customPropTypes.every([customPropTypes.disallow(['primary']), PropTypes.bool]), accessibility: PropTypes.func });
    Button.defaultProps = {
        as: 'button',
        accessibility: buttonBehavior,
    };
    Button.Group = ButtonGroup;
    return Button;
}(UIComponent));
Button.create = createShorthandFactory(Button, 'content');
export default Button;
